export const NO_RUNNING_ACTIONS = new Set();
